import { twMerge } from 'tailwind-merge';
import clsx, { ClassValue } from 'clsx';
import { IArgument } from '@newo/api/gateway';

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const getArgumentsDictionary = (args: IArgument[]) =>
    args.reduce<Record<string, string>>((accumulator, arg) => {
        accumulator[arg.name] = arg.value;
        return accumulator;
    }, {});
